var map = {
	"./Du-an-20.svg": 338,
	"./Giao-thong-20.svg": 339,
	"./Quy-hoach-20.svg": 340,
	"./Xay-dung-20.svg": 341,
	"./arrow-down.svg": 784,
	"./arrow-left-white.svg": 785,
	"./arrow-right-black.svg": 786,
	"./arrow-right-outline-color.svg": 787,
	"./arrow-right-outline.svg": 788,
	"./arrow-right-white.svg": 789,
	"./bx-user-circle.svg": 790,
	"./circle.svg": 373,
	"./close-black.svg": 381,
	"./close.svg": 791,
	"./closeX.svg": 374,
	"./cursor.svg": 375,
	"./delete.svg": 367,
	"./document-duplicate.svg": 452,
	"./email-footer.svg": 792,
	"./feather_clock.svg": 793,
	"./filter.svg": 794,
	"./finger.svg": 795,
	"./first.svg": 796,
	"./full-download.svg": 797,
	"./full-screen.svg": 798,
	"./grid-chart-solid.svg": 799,
	"./guide.svg": 800,
	"./info.svg": 801,
	"./information.svg": 382,
	"./last.svg": 318,
	"./layer-color.svg": 508,
	"./layer.svg": 802,
	"./layers.svg": 803,
	"./lineString.svg": 376,
	"./locate.svg": 315,
	"./location-pointer.svg": 804,
	"./map-filled.svg": 805,
	"./map-outline-01.svg": 806,
	"./map-outline-02.svg": 807,
	"./marker.svg": 808,
	"./md-document-duplicate.svg": 809,
	"./md-download.svg": 810,
	"./measureArea.svg": 811,
	"./next.svg": 812,
	"./paper.svg": 447,
	"./pdf-file.svg": 813,
	"./phone-call-footer.svg": 814,
	"./photo.svg": 815,
	"./place-footer.svg": 816,
	"./place.svg": 317,
	"./planning-name.svg": 316,
	"./polygon.svg": 377,
	"./position.svg": 817,
	"./prev.svg": 818,
	"./print.svg": 819,
	"./radius.svg": 378,
	"./ruler.svg": 820,
	"./search-circle.svg": 372,
	"./search-sidebar.svg": 821,
	"./search.svg": 379,
	"./searchLocation.svg": 822,
	"./selectArea.svg": 823,
	"./selectOne.svg": 824,
	"./settings-gears.svg": 825,
	"./slideshow.svg": 826,
	"./th-list.svg": 827,
	"./user.svg": 828,
	"./zoomIn.svg": 829,
	"./zoomOut.svg": 830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;